import React from "react";
import "../styles/Services.css";
import Rtgs from "../assets/photos/rtgs-neft.png";
import PmSuraksha from "../assets/photos/pm-suraksha.png";
import PmJeevan from "../assets/photos/pm-jeevan.png";
import AnnaPatil from "../assets/photos/anna-patil.png";
import { Link } from "react-router-dom";

function Services() {
  return (
    <div className="services-page">

      {/* HERO SECTION */}

      <section className="services-hero">
        <h1>Banking Services</h1>
        <p>Secure, fast and reliable banking solutions for individuals and businesses</p>
      </section>


      {/* MAIN SERVICES */}

      <section className="services-section">

        <h2 className="section-title">Our Banking Services</h2>

        <div className="services-grid">

          <div className="service-card">
            <img
              src="https://media.istockphoto.com/id/626723290/photo/hand-holding-key-and-opening-small-vault.webp?a=1&b=1&s=612x612&w=0&k=20&c=ov3qJfCOnvhuOMQAgwUxGdUNYqpHOhdQf-APlSebtTA="
              alt="locker"
            />

            <h3>Locker Facility</h3>

            <p>
              Elevate your asset security with our bank's locker facility,
              where your treasures are guarded with uncompromising security.
            </p>

            <Link to="/locker-facility" className="know-btn">
              Know More
            </Link>
          </div>


          <div className="service-card">
            <img
              src={Rtgs}
              alt="rtgs"
            />

            <h3>RTGS / NEFT</h3>

            <p>
              RTGS ensures lightning-fast transfers above ₹2,00,000 while
              NEFT offers nationwide convenience with extended banking hours.
            </p>

            <Link to="/rtgs-neft" className="know-btn">
              Know More
            </Link>
          </div>


          <div className="service-card">
            <img
              src="https://images.unsplash.com/photo-1571867424488-4565932edb41?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8bW9iaWxlJTIwYmFua2luZ3xlbnwwfHwwfHx8MA%3D%3D"
              alt="mobile banking"
            />

            <h3>Mobile Banking</h3>

            <p>
              Check your account balance anytime anywhere using our
              easy-to-use mobile banking platform.
            </p>

            <Link to="/mobile-banking" className="know-btn">
              Know More
            </Link>
          </div>

        </div>
      </section>



      {/* GOVERNMENT SCHEMES */}

      <section className="scheme-section-services">

        <h2 className="section-title">Government Schemes</h2>

        <div className="scheme-grid-services">

          <div className="scheme-card-services">

            <img src={PmSuraksha} alt="pm-suraksha"/>

            <h3>Pradhan Mantri Suraksha Bima Yojana (PMSBY)</h3>

            <p>
              Accident insurance scheme offering accidental death and
              disability coverage for one year renewable annually.
            </p>

            <Link to="/pmsby" className="know-btn">
              Know More
            </Link>

          </div>


          <div className="scheme-card-services">

          <img src={PmJeevan} alt="pm-jeevan"/>

            <h3>Pradhan Mantri Jeevan Jyoti Bima Yojana (PMJJBY)</h3>

            <p>
              One year renewable life insurance scheme providing financial
              security for families in case of unfortunate events.
            </p>

            <Link to="/pmjjby" className="know-btn">
              Know More
            </Link>

          </div>


          <div className="scheme-card-services">
            <img src={AnnaPatil} alt="anna-patil"/>

            <h3>Annasaheb Patil Arthik Magas Vikas Mahamandal</h3>

            <p>
              Government initiative to support entrepreneurship and
              employment opportunities for economically backward communities.
            </p>

            <Link to="/apamvm" className="know-btn">
              Know More
            </Link>

          </div>

        </div>

      </section>

      {/* WHY CHOOSE US */}

      <section className="why-section-services">

        <h2 className="section-title">Why Choose Our Services</h2>

        <div className="why-grid-services">

          <div className="why-card">
            <span>🔐</span>
            <h4>Secure Banking</h4>
            <p>Advanced security systems protect your finances.</p>
          </div>

          <div className="why-card">
            <span>⚡</span>
            <h4>Fast Transactions</h4>
            <p>Instant money transfers and quick banking services.</p>
          </div>

          <div className="why-card">
            <span>📱</span>
            <h4>Digital Banking</h4>
            <p>Access your account anytime using digital platforms.</p>
          </div>

          <div className="why-card">
            <span>🏦</span>
            <h4>Trusted Institution</h4>
            <p>Years of trusted service to our valued customers.</p>
          </div>

        </div>

      </section>



      {/* CONTACT CTA */}

      <section className="service-contact">

        <h2>Need Help With Our Services?</h2>

        <p>Our banking experts are ready to assist you.</p>

        <Link to="/contact" className="contact-btn">
          Contact Us
        </Link>

      </section>

    </div>
  );
}

export default Services;